import React from 'react';

function ClinicLogoPanel({clinicInfo}) {
    if (!clinicInfo?.logo) return null;

    return (
        <div className="clinic-info-logo-panel">
            <div className="clinic-info-logo-wrap">
                <img
                    src={clinicInfo.logo}
                    alt={clinicInfo.name ? `${clinicInfo.name} logo` : 'Clinic logo'}
                    className="clinic-info-logo"
                />
            </div>
        </div>
    );
}

export default ClinicLogoPanel;
